export default "__VITE_ASSET__Cvygmi6f__"